<template>
  <div>
    <div v-if="wait">
      <Spinner
        message="Loading..."
        :size="6"
      />
    </div>
    <div v-else>
      <div class="p-2 max-w-xl">
        <div class="flex flex-col gap-4">
          <div class="mt-4">
            Selecting "Complete" will mark this request for notification.
          </div>
          <div class="flex flex-col w-full">
            <div class="w-1/2 text-sm">
              Preload future changes before confirming.
            </div>
            <SubmitButton
              type="submit"
              color="gray"
              size="md"
              class="mx-2 mt-2 mb-4 rounded-md w-full !shadow disabled:bg-gray-100 disabled:text-gray-400"
              :disabled="!enableLoadScheduleButton"
              :submitting="isLoadingSchedule"
              @click="onUserLoadNewSchedule">
              Load New Schedule
            </SubmitButton>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2"
        v-if="loadNewSchedule">
        <div class="flex flex-col">
          <div class="flex flex-row ml-4">
            <div class="p-2 font-bold text-lg">
              Future Schedule
            </div>
            <button
              class="text-xs font-italics bg-gray-200 p-2 rounded-full hover:bg-gray-100"
              @click="scrollToValidateButton">
              Scroll to Validation
            </button>
          </div>
          <FutureScheduleMiscDataDisplay class="p-2"
            :miscData="scheduleMiscData"
          />
          <Schedule
            :emptySchedule="emptySchedule"
            :defaultExpandAllDays="true"
            :scheduleData="scheduleData"
            :scheduleDataDiff="scheduleDataDiff"
          />
        </div>
        <div class="flex flex-col shadow-sm p-2 gap-2">
          <ListChanges
            v-if="showListChanges"
            class="mx-2"
            :scheduleDataDiff="scheduleDataDiff"
          />
          <div class="flex flex-col">
            <Button
              ref="validateButton"
              color="blue"
              size="md"
              class="mx-2 mt-2 w-96 rounded-md !shadow"
              :disabled="futureChangesValidated"
              @click="onValidateChanges">
              {{ validateButtonDisplay }}
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../Button.vue'
import SubmitButton from '../SubmitButton.vue'
import Spinner from '../Spinner.vue'

import Schedule from '../schedule/Schedule.vue'
import ListChanges from '../schedule/sections/ListChanges.vue'

import FutureScheduleMiscDataDisplay from './FutureScheduleMiscDataDisplay.vue'

import scheduleService from '../../services/studentSchedule/schedule.js'

export default {
  components: {
    Button,
    SubmitButton,
    Spinner,
    Schedule,
    ListChanges,
    FutureScheduleMiscDataDisplay,
  },
  props: {
    studentDbId: Number,
    scheduleRequestId: Number,
    existingFutureScheduleId: Number,
    showLoadNewScheduleSection: Boolean,
    wait: Boolean,
  },
  data() {
    return {
      enableLoadScheduleButton: true,
      loadNewSchedule: false,
      isLoadingSchedule: false,

      emptySchedule: false,
      scheduleData: undefined,
      scheduleDataDiff: undefined,

      futureSchedule: undefined,
      futureChangesValidated: false,
    }
  },
  methods: {
    init() {
      this.onLoadSchedule()
    },
    async uiActionsForLoadSchedule(futureScheduleLoadCallback, scheduleDiffLoadCallback) {
      this.$emit('loadSchedule')
      this.enableLoadScheduleButton = false
      this.loadNewSchedule = true
      this.isLoadingSchedule = true
      this.emptySchedule = false
      this.futureChangesValidated = false
      try {
        this.scheduleData = await futureScheduleLoadCallback()
        this.scheduleDataDiff = await scheduleDiffLoadCallback()
      }
      catch (error) {
        this.emptySchedule = true
      }
      finally {
        this.enableLoadScheduleButton = true
        this.isLoadingSchedule = false
        this.$emit('loadScheduleComplete')
      }
    },
    async loadSchedule(futureScheduleId) {
      return this.uiActionsForLoadSchedule(
        () => {
          return scheduleService.getFutureSchedule(this.studentDbId, futureScheduleId, this.scheduleRequestId)
        },
        () => {
          return scheduleService.getScheduleDiffFromServer(
            this.studentDbId,
            'future', futureScheduleId,
            'request', undefined,
          )
        }
      )
    },
    async onLoadSchedule() {
      if (this.existingFutureScheduleId == undefined) {
        return this.loadSchedule(undefined)
      }
      else {
        return this.loadSchedule(this.existingFutureScheduleId)
      }
    },
    async onUserLoadNewSchedule() {
      return this.uiActionsForLoadSchedule(
        () => {
          return scheduleService.initiateFutureSchedulePull(this.studentDbId, this.scheduleRequestId, true)
        },
        () => {
          return {}
        }
      )
    },
    onValidateChanges() {
      this.futureChangesValidated = true
      this.$emit('validateChanges')
    },
    scrollToValidateButton() {
      let ref = this.$refs.validateButton
      this.$emit('scrollToValidate', ref)
      ref.$el.scrollIntoView({
        behavior: 'smooth',
      })
    },
  },
  mounted() {
    if (this.wait) {
      return
    }

    this.init()
  },
  computed: {
    validateButtonDisplay() {
      return 'Validate Changes'
    },
    showListChanges() {
      return false
    },
    scheduleMiscData() {
      return this.scheduleData?.misc
    }
  },
  watch: {
    wait(newValue) {
      if (!newValue) {
        this.init()
      }
    },
  },
}
</script>
